
import { Component, Vue, Ref } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { ElForm } from 'element-ui/types/form'
import { CodeToText } from '@/common/area_data'
import { CommonService } from '@/services'

@Component({
    name: 'recruit-create'
})
export default class extends Vue {
    @Ref('staffForm') private staffEl!: ElForm
    private isLoading = true
    private createLoading = false
    private staff: any = {
        name: '',
        type: '',
        region: '',
        duty: '',
        require: ''
    }
    private rules = {
        name: [
            { required: true, message: '请输入职位名', trigger: 'blur' },
            { max: 20, message: '职位名不能超过20个字符', trigger: 'blur' }
        ],
        type: { required: true, message: '请输入职位类型', trigger: 'blur' },
        region: { required: true, message: '请选择工作地点', trigger: 'blur' },
        duty: { required: true, message: '岗位职责不能为空', trigger: 'blur' },
        require: { required: true, message: '岗位要求不能为空', trigger: 'blur' }
    }

    get provinceAndCityData() {
        return AppModule.provinceAndCity
    }

    private async mounted() {
        this.isLoading = true
        await this.fetchRegion()
        this.isLoading = false
    }

    private async fetchRegion() {
        await AppModule.getRegion()
    }

    private onSelectRegion(value: any) {
        this.staff.region = value
    }

    // code to 中文
    private convertCodeToText(code: any) {
        if (!code) return ''
        let [provinceCode, cityCode] = code
        let text = ''
        let province = CodeToText[provinceCode]
        let city = CodeToText[cityCode]
        if (provinceCode && province) {
            text += province
            if (cityCode && CodeToText[cityCode]) {
                text += ',' + city
            }
        }
        return text
    }

    private onCreate() {
        this.staffEl.validate(valid => {
            if (!valid) return
            const region = this.convertCodeToText(this.staff.region).split(',')
            const params = {
                name: this.staff.name,
                type: this.staff.type,
                province: region[0],
                city: region[1] || '市辖区',
                duty: this.staff.duty,
                require: this.staff.require
            }
            this.create(params)
        })
    }

    private async create(params: any) {
        this.createLoading = true
        const result = await CommonService.createStaff(params)
        this.createLoading = false
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '创建成功',
                showClose: true
            })
            this.staffEl.resetFields()
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })

    }
}
